import React, { Component } from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import * as userStationsReducers from '../../system/reducer/UserStationsReducers';
import * as fastDataReducerManager from '../../fast-data/reducer';
import * as Reducers from '../reducer';

import * as actionMgr from '../action-mgr';

import * as strings from '../../helpers/strings';
import { getFastDataStationId } from '../../helpers/common';
// importing Css
import '../../index.css';

const styles = {
  graphViewButton: { height: 30, border: "1px solid rgba(0,0,0,0.5)", lineHeight: "30px", paddingLeft: 16, paddingRight: 16 },
  selected: { background: "rgba(0,0,0,0.1)" }
}

class DMYLineGraphScreen extends Component {

  constructor() {
    super();
    this.handleSelectField = this.handleSelectField.bind(this);
    this.handleSelectFieldFilter = this.handleSelectFieldFilter.bind(this);

    this.state = {
      selectFilter: 'all',
    }
  }

  componentDidMount() {
    const { stations, getFindRealTimeFields, resetSelectFields } = this.props;
    let defaultStation;

    if (stations.length > 0) {

      if (stations.filter(station => station.id === getFastDataStationId()).length !== 0) {
        defaultStation = stations.filter(station => station.id === getFastDataStationId())[0].name;
      } else {
        defaultStation = stations[0].name;
      }
      resetSelectFields();
      getFindRealTimeFields(defaultStation);
    }
  }

  handleSelectField(e) {
    const { setSelectedFieldIndex, setSelectedField } = this.props;
    setSelectedFieldIndex(e.currentTarget.getAttribute("data-id"));
    setSelectedField(e.target.value)
  }

  handleSelectFieldFilter(e) {
    this.setState({ selectFilter: e.target.value })
  }

  render = () => {
    const { getFindStationRealtimeFields, selectedField, resetSelectFields, getAllLastData } = this.props;
    return (
      <Paper >
        {(getFindStationRealtimeFields.length > 0) ?
          <div>
            <Table  className="filterParamTable">
            <TableHead>
              <TableRow>
                <TableCell colSpan={2}> {/* Use colSpan to span multiple columns if needed */}
                  <div className='params'>
                    <div className='paramLabels'>
                      <p className='paramName'>{strings.lblParametersName}</p>
                      <p className='paramType'>{strings.lblParametersType}</p>
                    </div>
                    <div className='filterParamTypeFastData'>
                      <FormControl margin={strings.txtNormal} style={{ margin: '0px 10px', display: 'inline-block' }}>
                        <Select
                          value={this.state.selectFilter}
                          onChange={this.handleSelectFieldFilter}
                          style={{ fontSize: "11px" }}
                        >
                          {(() => {
                            const options = [];
                            const filterTypes = ['all'];
                            options.push(<MenuItem key="all" value={'all'}>All</MenuItem>);
                            Object.entries(getFindStationRealtimeFields[0]).forEach(([key, value], index) => {
                              if (value !== "" && filterTypes.indexOf(value) === -1 && key !== "irradiance_field") {
                                options.push(
                                  <MenuItem key={value} value={value}>{value}</MenuItem>
                                );
                                filterTypes.push(value);
                              }
                            });
                            return options;
                          })()}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            </TableHead>

            </Table >

            <div className="filterFieldsTableWrapper">
              <Table className="filterFieldsTable">
              <TableBody>
              {Object.entries(getFindStationRealtimeFields[0]).map(([key, value], index) => (
                <TableRow 
                  key={`${key}-${index}`} // Unique key
                  style={{ display: ((value !== "" && this.state.selectFilter === "all") || (this.state.selectFilter === value)) ? "" : 'none' }}
                >
                  <TableCell>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedField.includes(key)}
                          value={key}
                          color={strings.colorPrimary}
                          data-id={index + 1}
                          onClick={this.handleSelectField} />
                      }
                      label={(getAllLastData !== null) ? `${key} (${getAllLastData.Data[index] / 10})` : key}
                    />
                  </TableCell>
                  <TableCell>
                    {value}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

              </Table>
            </div>
          </div>
          : ''}
      </Paper>

    );
  }
}

const mapStateToProps = state => ({
  stations: userStationsReducers.getStations(state),
  getFindStationRealtimeFields: Reducers.getFindStationRealtimeFields(state),
  selectedField: Reducers.getSelectedField(state),
  getAllLastData: fastDataReducerManager.getAllLastData(state),
});

const mapActionsToProps = {
  getFindRealTimeFields: actionMgr.getFindRealTimeFields,
  setSelectedFieldIndex: actionMgr.selectFieldsIndex,
  setSelectedField: actionMgr.selectFields,
  resetSelectFields: actionMgr.resetSelectFields,
};

export default connect(mapStateToProps, mapActionsToProps)(
  withStyles(styles)(DMYLineGraphScreen)
);